<template>
  <el-card shadow="never" class="card ticket-stats-card">
    <div slot="header" class="card-header">
      <i class="el-icon-tickets"></i>
      <span>票种类型</span>
    </div>

    <el-row :gutter="16">
      <el-col v-for="opt in ticketTypeOptions" :key="opt" :span="cols">
        <div
          class="stat"
          :style="(function(){ const bg=bgColorFor(opt); const txt = bg ? textColorFor(bg) : undefined; return bg ? { background: bg, color: txt } : {}; })()"
        >
          <div class="stat-title">{{ opt }} 数量</div>
          <div class="stat-value">{{ statsMap[opt] || 0 }}</div>
        </div>
      </el-col>
    </el-row>

    <div class="hint">票种数量将根据每位游客选择的“票种类型”自动统计</div>
    <!-- debug output removed -->
  </el-card>
</template>

<script>
export default {
  name: 'TicketTypeStats',
  props: {
    visitors: {
      type: Array,
      required: true
    },
    ticketTypeOptions: {
      type: Array,
      default: () => []
    },
    ticketTypeColors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statsMap: {}
    }
  },
 
  // 统计数据由 visitors watcher 驱动并写入 statsMap
  watch: {
    visitors: {
      handler() {
        this.computeStats()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    computeStats() {
      // Build counts but map them to the display keys in ticketTypeOptions.
      // This handles cases like '成人' vs '成人票' by fuzzy matching.
      const displayKeys = (this.ticketTypeOptions || []).slice()
      const map = {}
      displayKeys.forEach(k => { map[k] = 0 })

      const normalize = s => (s === null || s === undefined) ? '' : String(s).trim()

      ;(this.visitors || []).forEach(v => {
        const raw = normalize(v && v.ticketType)
        if (!raw) return

        // try exact match to display key
        let matched = false
        for (const dk of displayKeys) {
          if (!dk) continue
          const dks = normalize(dk)
          if (dks === raw) {
            map[dk]++
            matched = true
            break
          }
        }
        if (matched) return

        // try fuzzy match: display key includes raw or raw includes display key
        for (const dk of displayKeys) {
          if (!dk) continue
          const dks = normalize(dk)
          if (dks && (dks.includes(raw) || raw.includes(dks))) {
            map[dk]++
            matched = true
            break
          }
        }
        if (matched) return

        // fallback: count under raw as its own key (also ensure it's visible in map)
        if (!Object.prototype.hasOwnProperty.call(map, raw)) map[raw] = 0
        map[raw] = (map[raw] || 0) + 1
      })

      try {
        console.log('[TicketTypeStats] stats computed (watcher)', map, { visitors: this.visitors })
      } catch (e) {
        console.error(e)
      }
      this.statsMap = map
    },
    bgColorFor(option) {
      if (!option) return null
      // exact
      if (this.ticketTypeColors && this.ticketTypeColors[option]) return this.ticketTypeColors[option]
      // loose match e.g. '成人票' vs '成人'
      if (this.ticketTypeColors) {
        for (const k of Object.keys(this.ticketTypeColors)) {
          if (!k) continue
          if (String(k).includes(option) || String(option).includes(k)) {
            return this.ticketTypeColors[k]
          }
        }
      }
      return null
    },
    textColorFor(bg) {
      if (!bg) return '#409eff'
      // strip #
      const hex = String(bg).replace('#', '')
      if (hex.length === 3) {
        const r = parseInt(hex[0] + hex[0], 16)
        const g = parseInt(hex[1] + hex[1], 16)
        const b = parseInt(hex[2] + hex[2], 16)
        const yiq = (r * 299 + g * 587 + b * 114) / 1000
        return yiq >= 128 ? '#000' : '#fff'
      } else if (hex.length === 6) {
        const r = parseInt(hex.substr(0, 2), 16)
        const g = parseInt(hex.substr(2, 2), 16)
        const b = parseInt(hex.substr(4, 2), 16)
        const yiq = (r * 299 + g * 587 + b * 114) / 1000
        return yiq >= 128 ? '#000' : '#fff'
      }
      return '#fff'
    }
  },
  computed: {
    cols() {
      const n = Math.max(1, (this.ticketTypeOptions || []).length || 1)
      // compute span (24 grid) but keep minimum width
      const span = Math.max(6, Math.floor(24 / n))
      return span
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.ticket-stats-card {
  margin: 32px 0;
  padding: 12px 18px;
  box-shadow: none;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #409eff;
  font-weight: 700;
}

.stat {
  height: 74px;
  border: 1px solid #d9ecff;
  background: #ecf5ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10px 0;
}

.stat-title {
  font-size: 12px;
  color: inherit;
}

.stat-value {
  margin-top: 6px;
  font-size: 20px;
  font-weight: 800;
  color: inherit;
}

.hint {
  padding-top: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
